/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Xml_Feed_PauseInputs */

const cs_xml_feed_pause = /** @type {(inputs: Xml_Feed_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozastavit feed`)
};

const en_xml_feed_pause = /** @type {(inputs: Xml_Feed_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause feed`)
};

/**
* | output |
* | --- |
* | "Pause feed" |
*
* @param {Xml_Feed_PauseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const xml_feed_pause = /** @type {((inputs?: Xml_Feed_PauseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Xml_Feed_PauseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_xml_feed_pause(inputs)
	return cs_xml_feed_pause(inputs)
});